import { Container, Dialog, DialogTitle } from "@mui/material";
import { Loading } from "./Loading";

export interface LoadingDialogProps {
	isOpen: boolean;
	message: string;
	onLoadingClose?: () => void;
}
export const LoadingDialog = ({ isOpen, message, onLoadingClose }: LoadingDialogProps) => {
	return (
		<Dialog 
			aria-labelledby="loading-dialog-title" 
			open={isOpen} 
			onClose={onLoadingClose}
			keepMounted={false}
			disableRestoreFocus
		>
			<Container>
				<DialogTitle id="loading-dialog-title">Processing</DialogTitle>
				<Loading message={message} />
			</Container>
		</Dialog>
	);
};
